import PropTypes from "prop-types";
import React, { Component } from "react";

import "./_style.scss";
import ContentSwitcherElement from "./element";
import LinkButton from "../LinkButton";
import LinkButtonGroup from "../LinkButtonGroup";

class ContentSwitcher extends Component {
  static propTypes = {
    buttonsBelow: PropTypes.bool,
  };

  static defaultProps = {
    buttonsBelow: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      elements: this.props.children,
      visible_id: this.props.children[0].props.id,
    };
  }

  visibleToggle = (id) => {
    if (this.state.visible_id !== id) {
      this.setState({
        visible_id: id,
      });
    }
  };

  buildElement = (element, key) => (
    <ContentSwitcherElement
      key={key}
      id={element.id}
      visible={element.id === this.state.visible_id}
      button_text={element.button_text}
    >
      { element.children }
    </ContentSwitcherElement>
  );

  buildButtons = (element, key) => (
    <LinkButton
      key={key}
      id={element.id}
      isBold={element.id === this.state.visible_id}
      look={element.id === this.state.visible_id ? "secondary" : "secondary-outline"}
      onClick={() => this.visibleToggle(element.id)}
      size="large"
    >
      { element.button_text }
    </LinkButton>
  );

  renderButtons = (top, buttons) => {
    if ((top === true && this.props.buttonsBelow === false) || (top === false && this.props.buttonsBelow === true)) {
      return (
        <div className="switcher-container">
          <LinkButtonGroup>
            {buttons}
          </LinkButtonGroup>
        </div>
      );
    }

    return "";
  };

  render() {
    const contentElements = this.state.elements.map((item, key) => this.buildElement(item.props, key), this);
    const switcherElements = this.state.elements.map((item, key) => this.buildButtons(item.props, key), this);

    return (
      <div className="content-switcher-container">
        {this.renderButtons(true, switcherElements)}
        <div className="content-container">
          {contentElements}
        </div>
        {this.renderButtons(false, switcherElements)}
      </div>
    );
  }
}

export default ContentSwitcher;
